import { render, staticRenderFns } from "./SouscriptionProjet.vue?vue&type=template&id=48f647d2&scoped=true&"
import script from "./SouscriptionProjet.vue?vue&type=script&lang=js&"
export * from "./SouscriptionProjet.vue?vue&type=script&lang=js&"
import style0 from "./SouscriptionProjet.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./SouscriptionProjet.vue?vue&type=style&index=1&id=48f647d2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48f647d2",
  null
  
)

export default component.exports